import rootReducer from "../../../store";
import { setOrganizationRelationshipData } from "../../../slices/org/organizationRelationshipSlice";
import {
  editModal,
  openModal,
  RenderPage,
  resetFormState,
} from "../../../slices/common/reducer";
import { showToast } from "../../../common/Toaster/Toaster";
import api from "../../../Utils/interface";

export const getOrgRelationshipListing = (organizationId) => {
  let fd = new FormData();

  fd.append("organizationId", organizationId);
  api
    .post(`/agsp/organization/getAllRelationshipData`, fd)
    .then((res) => {
      console.log(res.data);
      rootReducer.dispatch(setOrganizationRelationshipData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export let createOrgRelationship = async (
  entity,
  organization_id,
  organization_type
) => {
  const updatedEntity = {
    ...entity,
    organization_id: organization_id,
    organization_type: organization_type,
  };
  //   let fd = new FormData();
  //   fd.append("entity", JSON.stringify(updatedEntity));

  await api
    .post(`/agsp/organization/createOrganizationRelationship`, updatedEntity, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(openModal(false));
      showToast("Organization Relationship added successfully", "success");
    })
    .catch((error) => {
      // const roleName = entity.name;
      showToast(error?.response?.data?.error_message, "error");
    });
};

export let updateOrgRelationship = async (entity) => {
  let fd = new FormData();
  Object.keys(entity).forEach((key) => {
    fd.append(key, entity[key]);
  });

  try {
    const response = await api.post(
      `/agsp/organization/updateOrganizationRelationship`,
      fd,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Assuming these are Redux actions to update state or handle UI
    rootReducer.dispatch(RenderPage());
    rootReducer.dispatch(resetFormState());
    rootReducer.dispatch(editModal(false));
    rootReducer.dispatch(openModal(false));

    showToast("Org Relationship Updated Successfully!", "success");
  } catch (error) {
    showToast(error?.response?.data?.error_message, "error");
  }
};
